import React from 'react';
import { Col, Row, Text } from 'components';
import { FontAwesome5 } from '@expo/vector-icons';
import { StyleSheet } from 'react-native';

const WARNING = '#F5A623';
const SUCCESS = '#1FA463';
const STEEL_GREY = '#E0E2E5';

interface DriverLeaderboardProps {
  drivers?: Array<{
    driverReference: string;
    driverName: string;
    totalOrders: number;
    ordersWithIssues: number;
    issueFreeRate: number;
  }>;
}

const DriverLeaderboard: React.FC<DriverLeaderboardProps> = ({ drivers = [] }) => {
  const displayDrivers = drivers.slice(0, 3).map((driver, index) => {
    const rank = index + 1;
    const issueText = driver.ordersWithIssues === 1 ? 'issue' : 'issues';
    const score = `${driver.issueFreeRate.toFixed(1)}% • ${driver.ordersWithIssues} ${issueText}`;
    
    const bgColors = ['#FFF8E6', '#F3F4F6', '#FFEDD5'];
    
    return {
      rank,
      name: driver.driverName || driver.driverReference,
      score,
      bg: bgColors[index] || '#F3F4F6',
    };
  });
  
  if (displayDrivers.length === 0) {
    displayDrivers.push(
      { rank: 1, name: 'No data available', score: 'N/A', bg: '#F3F4F6' }
    );
  }

  return (
    <Col style={styles.chartCard}>
      <Row alignItems="center" marginBottom={16}>
        <FontAwesome5 name="trophy" size={14} color={WARNING} style={{ marginRight: 8 }} />
        <Text fontSize={14} bold color="#374151" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
          TOP PERFORMERS TODAY
        </Text>
      </Row>
      {displayDrivers.map((driver) => (
        <Row
          key={driver.rank}
          justifyContent="space-between"
          alignItems="center"
          style={[styles.driverRow, { backgroundColor: driver.bg }]}
          marginBottom={12}
        >
          <Row alignItems="center">
            <Col
              style={[
                styles.rankBadge,
                {
                  backgroundColor: driver.rank === 1 ? WARNING : driver.rank === 2 ? STEEL_GREY : '#FB923C',
                },
              ]}
            >
              <Text fontSize={12} bold color="white">
                {driver.rank}
              </Text>
            </Col>
            <Text fontSize={14} semiBold marginLeft={12}>
              {driver.name}
            </Text>
          </Row>
          <Text fontSize={14} bold style={{ color: SUCCESS }}>
            {driver.score}
          </Text>
        </Row>
      ))}
    </Col>
  );
};

const styles = StyleSheet.create({
  chartCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: STEEL_GREY + '80',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
    marginBottom: 16,
  },
  driverRow: {
    padding: 8,
    borderRadius: 8,
  },
  rankBadge: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default DriverLeaderboard;

